import {isLink} from '../util/editChecks'

export const validateAddress = (value) => {
    let error;
    if (!value) {
        error = 'Address is required';
    } else if (value.length>55) {
        error = 'Maximum of 55 characters';
    }
    return error;
}

export const validateCity = (value) => {
    let error;
    if (!value) {
        error = 'City is required';
    } else if (value.length>45) {
        error = 'Maximum of 45 characters';
    }
    return error;
}

export const validatePostalCode = (value) => {
    let error;
    if (!value) {
        error = 'Postal Code is required';
    } else if (value.length !== 6) {
        error = 'Postal Code must be 6 characters';
    }
    return error;
}

export const validateBuildingId = (value) => {
    let error;
    if (!value) {
        error = 'Building ID is required';
    }
    return error;
}

export const validateBuildingName = (value) => {
    let error;
    if (!value) {
        error = 'Building Name is required';
    } else if (value.length > 50) {
        error = 'Maximum of 50 characters';
    }
    return error;
}

export const validateSize = (value) => {
    let error;
    if (!value) {
        error = 'Size is required';
    } else if (value > 1000000) {
        error = 'Size has to be under 1000000';
    }
    return error;
}

export const validateText = (value) => {
    let error;
    if (value&&value.length > 256) {
        error = 'Maximum of 256 characters';
    }
    return error;
}

export const validateUrl = (value) => {
    let error;
    if (value&&!isLink(value)) {
        error = 'Invalid URL. It has to be https or http format.';
    }
    return error;
}

export const validateFieldName = (value) => {
    let error;
    if (value&& value.length >= 30) {
        error = `${40 - value.length} characters left`;
    }
    return error;
}